// Remembers ?ref=CODE from any landing URL (homepage, challenge page, shared session...)
// for the signup page to send along. See utils/referral.ts.
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const capture = (query: Record<string, unknown>) => {
    const ref = Array.isArray(query.ref) ? query.ref[0] : query.ref
    if (ref) saveReferralCode(ref)
  }
  capture(router.currentRoute.value.query)
  router.afterEach(to => capture(to.query))
})
